import { STRATEGY_NOT, STRATEGY_OR } from 'Components/filters/config';

/**
 * Build the `__feature` payload for a feature filter. Shared by FilterList and
 * FilterAutocomplete so the feature value serialization stays identical across
 * filter types.
 *
 * @param {{ featureID: number|string, value: any, strategy: string, isNA?: boolean }} params
 */
/**
 * Map a feature's `valuesList` (`[{ id, name }]`, serializable — survives the
 * resource cache) into autocomplete items (`[{ text, value }]`). Items already
 * in `{ text, value }` shape are passed through unchanged.
 *
 * @param {Array<{id?: any, name?: string, value?: any, text?: string}>} valuesList
 */
export function featureOptionsToItems(valuesList = []) {
  return (valuesList || []).map((item) => {
    if (item && typeof item === 'object' && 'value' in item) {
      return item;
    }
    return { text: item?.name, value: item?.id };
  });
}

export function collectFeatureValue({ featureID, value, strategy, isNA = false }) {
  if (isNA) {
    return { [featureID]: null, not: true };
  }
  if (Array.isArray(value) && strategy !== STRATEGY_OR) {
    return value.map((opt) => {
      const entry = { [featureID]: opt };
      if (strategy === STRATEGY_NOT) {
        entry.not = true;
      }
      return entry;
    });
  }
  return { [featureID]: value };
}
